import React from 'react';
import { useParams } from 'react-router';

import AdminBrowseHomeEditPage from 'app/components/admin/browse/home/AdminBrowseHomeEditPage';

export function AdminBrowseHomeEditPageRoute() {
  const { browseHomePageId, localeCode } = useParams();

  return <AdminBrowseHomeEditPage browseHomePageId={browseHomePageId} localeCode={localeCode} />;
}

export default AdminBrowseHomeEditPageRoute;
